import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsDisputeSchema = withDefaults({
  type: 'pcs-dispute',
  fields: [
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'providerId',
    },
    {
      kind: 'attribute',
      name: 'providerData',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'pcsCard',
      type: 'pcs-card',
      options: {
        async: false,
        inverse: 'pcsDisputes',
      },
    },
  ],
});

export default PcsDisputeSchema;
